module.exports = __webpack_public_path__ + "static/img/ikonaBrudnopis-ON.d2307629.png";